module.exports = __webpack_public_path__ + "media/images/front/sp/institution-treatment-information/img_hospital-8b9401536c8475fbd852c06bbf9c7580.jpg";